export const subscriptionStatus = Object.freeze({
  READ: 'Read',
  UNREAD: 'Unread',
});
